/* eslint-disable no-undef */
// userSaga.js
import { call,  put,  takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { BOOK_SURGERY_TREATMENT_REQUEST, SURGICAL_TREATMENT_REQUEST } from './Constants';
import { bookSurgicaltreatmentRequestError, bookSurgicaltreatmentRequestSuccess, surgicaltreatmentRequestError, surgicaltreatmentRequestSuccess } from './Actions';
import { Modal } from 'antd';
// import { Modal } from 'antd';


function* surgicaltreatment(action) {

    try {    
        
        const url = `${process.env.REACT_APP_API_BASE_URL}/surgicaltreatment?specializationId=${action?.id}`;
  
        // // Example headers - You can add more headers as per your requirement
        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'Content-Type': 'application/json',
            Authorization: sessionStorage.jwt,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };
  
        // // const data = {};  // Data you want to send with the POST request (can be empty for a simple POST)
  

        const response = yield call(axios.get, url,{ headers});

        // // Check if the response is successful
        if (response.status === 200 || response.status === 201) {
            
            // Dispatch the success action with data and message      
            yield put(surgicaltreatmentRequestSuccess(response.data));
        } else {
            // Dispatch the failure action with the response message
            yield put(surgicaltreatmentRequestError('An error occurred.'));
        }

    } catch (error) {
        
        yield put(surgicaltreatmentRequestError('An error occurred.'));
        // throw error;
    // yield put(fetchUserFailure(error));
    }
}

function* postSurgicaltreatment (action) {
    try {    

        const surgeryTreatmentDetails = action.payload;
        
        const url = `${process.env.REACT_APP_API_BASE_URL}/surgeryreferral`;
  
        // // Example headers - You can add more headers as per your requirement
        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'Content-Type': 'application/json',
            Authorization: sessionStorage.jwt,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };
  
        const data = {
            fullName: surgeryTreatmentDetails.name,
            phoneNumber: surgeryTreatmentDetails.phoneNumber,
            emailAddress: surgeryTreatmentDetails.email,
            city: surgeryTreatmentDetails.city,
            specializationId: surgeryTreatmentDetails.departmentId,
            department: surgeryTreatmentDetails.department,
            hasInsurance: surgeryTreatmentDetails.insurance,
            surgicaltreatmentId: surgeryTreatmentDetails.surgicaltreatmentId,
            treatment: surgeryTreatmentDetails.treatment,
            message: surgeryTreatmentDetails.message,
        }; 
  

        const response = yield call(axios.post, url, data, { headers});

        // // Check if the response is successful
        if (response.status === 200 || response.status === 201) {
            Modal.success({
                title: 'Your consultation has been successfully booked. Our representative will contact you.'
            });
            // Dispatch the success action with data and message      
            yield put(bookSurgicaltreatmentRequestSuccess(response.data));
        } else {
            // Dispatch the failure action with the response message
            yield put(bookSurgicaltreatmentRequestError('An error occurred.'));
        }

    } catch (error) {
        
        yield put(bookSurgicaltreatmentRequestError('An error occurred.'));
        // throw error;
    // yield put(fetchUserFailure(error));
    }
}

// Watcher Saga
export function* watchFetchPlanMySurgery() {
    yield takeEvery(SURGICAL_TREATMENT_REQUEST, surgicaltreatment);
    yield takeEvery(BOOK_SURGERY_TREATMENT_REQUEST, postSurgicaltreatment);

}
